import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8338e00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "periodontal-map-table__columns" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick", "onMouseover"]
const _hoisted_7 = ["onClick", "onMouseover"]
const _hoisted_8 = ["onClick", "onMouseover"]
const _hoisted_9 = {
  key: 1,
  class: "periodontal-map-table__recession"
}
const _hoisted_10 = {
  key: 2,
  class: "periodontal-map-table__sounding"
}
const _hoisted_11 = {
  key: 3,
  class: "periodontal-map-table__sounding"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 0 }

import {
  computed,
  onMounted,
  PropType,
  ref,
} from 'vue'
import { useRoute } from 'vue-router'
import {
  getNextInputIndexByArrow,
  getTabDirection,
  removeSelectionRanges,
} from '@/entities/EPeriodontalMapTable/utils/periodontalMap'
import {
  DirectionType,
  PeriodontalParameterType,
} from '@/entities/EPeriodontalMapTable/types/periodontalMap.type'
import { PeriodontalDataType } from '@/shared/types'
import { TEETH_STATUSES } from '@/shared/constants'


export default /*#__PURE__*/_defineComponent({
  props: {
  isPdfMode: Boolean,
  isReverse: Boolean,
  isInteractive: Boolean,
  columns: Array as PropType<PeriodontalDataType[]>,
},
  emits: [
  'recession',
  'reset',
  'change-status',
  'plaque',
  'bleeding',
  'suppuration',
  'furation',
  'mobility',
  'sounding',
],
  setup(__props, { emit }) {

const props = __props





const route = useRoute()

const SHIFT_ALTERNATIVE_CHAR_NUMBER_REGEXP_ENGLISH = /([`)!@#$%^&*(`])/
const SHIFT_ALTERNATIVE_CHAR_NUMBER_REGEXP_RUSSIAN = /([`)!"№;%:?*(`])/
const CHAR_MINUS = '-'
const CHAR_MINUS_ALTERNATIVE = '_'

const recessionInputs = ref<HTMLInputElement[]>([])
const soundingInputs = ref<HTMLInputElement[]>([])

const LEGENDS = [
  'Подвижность (0-3)',
  'Фуркация (0-3)',
  'Зубной налёт',
  'Кровоточивость',
  'Гноетечение',
  'Рецессия',
  'Гл. зондирования',
]

const isPreviewMode = computed(() => route.query['view-mode'] === '1')
const periodontalMapData = computed((): PeriodontalDataType[] => props.columns)

const handleClickColumn = (event: MouseEvent, columnId: number): void => {
  if (event.shiftKey) {
    removeSelectionRanges()
    emit('reset', columnId)
  } else {
    emit('change-status', columnId)
  }
}

const handleChangePeriodontalParameter = (
  parameter: PeriodontalParameterType,
  columnId: number,
  parameterId: number
): void => {
  removeSelectionRanges()
  emit(parameter, columnId, parameterId)
}

const handleChangeFuration = (columnId: number, furationId: number): void => {
  emit('furation', columnId, furationId)
}

const handleChangeMobility = (columnId: number): void => {
  emit('mobility', columnId)
}

const getValidatedValue = (
  inputtedValue: string,
  isMinusCharInitialValue: boolean
): string => {
  const REG_EXP_NUMBER = /(\d+)/
  const RETURN_VALUE_WITH_INCORRECT_INPUT = '0'

  const onlyNumberString = inputtedValue.match(REG_EXP_NUMBER)

  if (onlyNumberString) {
    return isMinusCharInitialValue
      ? CHAR_MINUS + onlyNumberString[0]
      : onlyNumberString[0]
  }

  return RETURN_VALUE_WITH_INCORRECT_INPUT
}

const isShiftNumberInputMode = (inputtedValue: string) => {
  return (
    SHIFT_ALTERNATIVE_CHAR_NUMBER_REGEXP_ENGLISH.test(inputtedValue) ||
    SHIFT_ALTERNATIVE_CHAR_NUMBER_REGEXP_RUSSIAN.test(inputtedValue)
  )
}

const getShiftNumber = (value: string): string => {
  if (SHIFT_ALTERNATIVE_CHAR_NUMBER_REGEXP_ENGLISH.test(value)) {
    const shiftValue = value.match(SHIFT_ALTERNATIVE_CHAR_NUMBER_REGEXP_ENGLISH)
    return shiftValue[0]
  } else {
    const shiftValue = value.match(SHIFT_ALTERNATIVE_CHAR_NUMBER_REGEXP_RUSSIAN)
    return shiftValue[0]
  }
}

const translateShiftNumber = (shiftValue: string): string => {
  const SHIFT_ALTERNATIVE_CHAR_NUMBER_ENGLISH = ')!@#$%^&*('
  const SHIFT_ALTERNATIVE_CHAR_NUMBER_RUSSIAN = ')!"№;%:?*('
  let translattedShiftValue: number

  if (SHIFT_ALTERNATIVE_CHAR_NUMBER_REGEXP_ENGLISH.test(shiftValue)) {
    translattedShiftValue =
      SHIFT_ALTERNATIVE_CHAR_NUMBER_ENGLISH.indexOf(shiftValue)
  } else {
    translattedShiftValue =
      SHIFT_ALTERNATIVE_CHAR_NUMBER_RUSSIAN.indexOf(shiftValue)
  }

  return String(translattedShiftValue)
}

const getTranslattedShiftNumber = (value: string) => {
  const shiftNumber = getShiftNumber(value)

  return translateShiftNumber(shiftNumber)
}

const getPositionInitialValue = (
  totalValue: string,
  initialValue: string
): number => {
  return totalValue.indexOf(initialValue)
}

const isNegativeValue = (value: string) => {
  return value.includes(CHAR_MINUS)
}

const isMaxLengthInitialValue = (initialValue: string) => {
  const MAX_LENGTH_POSITIVE_INPUT_VALUE = 2
  const MAX_LENGTH_NEGATIVE_INPUT_VALUE = 3

  const isMaxLengthNegativeValue =
    isNegativeValue(initialValue) &&
    initialValue.length === MAX_LENGTH_NEGATIVE_INPUT_VALUE
  const isMaxLengthPositiveValue =
    !isNegativeValue(initialValue) &&
    initialValue.length === MAX_LENGTH_POSITIVE_INPUT_VALUE

  return isMaxLengthNegativeValue || isMaxLengthPositiveValue
}

const getProcessedInputtedValue = (
  inputtedValue: string,
  initialValue: string,
  totalValue: string
) => {
  const START_POSITION = 0
  const positionInitialValue = getPositionInitialValue(totalValue, initialValue)

  if (positionInitialValue === START_POSITION) {
    return initialValue + inputtedValue
  }

  if (isNegativeValue(initialValue)) {
    const absInitialValue = Math.abs(Number(initialValue))

    return `-${inputtedValue}${absInitialValue}`
  }

  return inputtedValue + initialValue
}

const handleShiftNumberInputMode = (
  initialValue: string,
  inputtedValue: string,
  totalValue: string
) => {
  const START_INPUT_VALUE = '0'
  const translattedShiftNumber = getTranslattedShiftNumber(inputtedValue)

  if (
    isMaxLengthInitialValue(initialValue) ||
    initialValue === START_INPUT_VALUE
  ) {
    return translattedShiftNumber
  } else {
    const proccessedValue = getProcessedInputtedValue(
      translattedShiftNumber,
      initialValue,
      totalValue
    )

    return proccessedValue
  }
}

const getInputtedValue = (totalValue: string, initialValue: string) => {
  const inputtedValue = totalValue[initialValue.length]

  return inputtedValue ?? totalValue
}

const getProccessedMinMaxValue = (
  value: number,
  type: 'recession' | 'sounding'
) => {
  const MAX_PERIODONTAL_VALUE = 20
  const min_value = type === 'recession' ? -20 : 0

  if (min_value <= value && value <= MAX_PERIODONTAL_VALUE) {
    return value
  }

  if (value > MAX_PERIODONTAL_VALUE) {
    return MAX_PERIODONTAL_VALUE
  }

  if (value < min_value) {
    return min_value
  }
}

const handleFocusOutInput = (
  value: number,
  columnId: number,
  recessionId: number,
  type: 'recession' | 'sounding'
) => {
  if (String(value) === CHAR_MINUS) {
    emit(type, columnId, recessionId, 0)
    return
  }
}

const moveCursorToEndValue = (
  value: number,
  columnId: number,
  recessionId: number,
  type: 'recession' | 'sounding'
) => {
  emit(type, columnId, recessionId, undefined)
  setTimeout(() => {
    emit(type, columnId, recessionId, value)
  }, 0)
}

const clearInputValue = (
  columnId: number,
  inputId: number,
  type: 'recession' | 'sounding'
) => {
  emit(type, columnId, inputId, 0)
}

const handleInput = (
  columnId: number,
  inputId: number,
  totalValue: string,
  initialValue: number,
  type: 'recession' | 'sounding'
): void => {
  const stringedInitialValue = String(initialValue)
  const isMinusCharInitialValue = stringedInitialValue === CHAR_MINUS
  const inputtedValue = getInputtedValue(totalValue, stringedInitialValue)

  let proccessedInputtedValue: string

  if (
    inputtedValue === CHAR_MINUS ||
    inputtedValue === CHAR_MINUS_ALTERNATIVE
  ) {
    emit(type, columnId, inputId, CHAR_MINUS)
    return
  }

  if (isShiftNumberInputMode(inputtedValue)) {
    proccessedInputtedValue = handleShiftNumberInputMode(
      stringedInitialValue,
      inputtedValue,
      totalValue
    )
  } else {
    proccessedInputtedValue = getValidatedValue(
      inputtedValue,
      isMinusCharInitialValue
    )
  }

  const proccessedMinMaxValue = getProccessedMinMaxValue(
    Number(proccessedInputtedValue),
    type
  )

  emit(type, columnId, inputId, proccessedMinMaxValue)
}

const isNumber = (value: string) => {
  return !Number.isNaN(Number(value))
}

const handleChangeInputByTab = (
  currentInput: KeyboardEvent,
  inputs: HTMLInputElement[],
  inputValue: number
): void => {
  const ONLY_NUMBER_REGEXP = /(\d+)/
  const MAX_LENGTH_INPUT_VALUE = 2

  if (
    !isNumber(currentInput.key) &&
    !isShiftNumberInputMode(currentInput.key)
  ) {
    return
  }

  const inputValueOnlyNumber = String(inputValue).match(ONLY_NUMBER_REGEXP)

  if (
    currentInput.shiftKey &&
    inputValueOnlyNumber &&
    inputValueOnlyNumber[0].length !== MAX_LENGTH_INPUT_VALUE
  ) {
    return
  }

  const currentInputId = (currentInput.target as HTMLInputElement).id
  const tabDirection = getTabDirection(currentInputId, inputs)

  const nextIndex = getNextInputIndexByArrow(
    inputs,
    currentInputId,
    tabDirection
  )

  inputs[nextIndex].focus()
}

onMounted((): void => {
  recessionInputs.value = [
    ...document.querySelectorAll('.periodontal-map-table__recession-item'),
  ].map((input) => input.children[0].children[0]) as HTMLInputElement[]

  soundingInputs.value = [
    ...document.querySelectorAll('.periodontal-map-table__sounding-item'),
  ].map((input) => input.children[0].children[0]) as HTMLInputElement[]
})

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
      'periodontal-map-table--reverse': __props.isReverse,
      'periodontal-map-table--preview': _unref(isPreviewMode) || __props.isPdfMode,
      'periodontal-map-table--interactive': __props.isInteractive,
    }, "periodontal-map-table"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'periodontal-map-table__legends--interactive': __props.isInteractive,
        'periodontal-map-table__legends--preview': _unref(isPreviewMode) || __props.isPdfMode,
      }, "periodontal-map-table__legends"])
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(LEGENDS, (legend) => {
        return _createElementVNode("p", {
          class: _normalizeClass([{
          'periodontal-map-table__legend--preview': _unref(isPreviewMode) || __props.isPdfMode,
          'periodontal-map-table__legend--interactive': __props.isInteractive,
        }, "periodontal-map-table__legend"])
        }, _toDisplayString(legend), 3)
      }), 64))
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(periodontalMapData), (column) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([{
          'periodontal-map-table__column--preview': _unref(isPreviewMode) || __props.isPdfMode,
          'periodontal-map-table__column--hidden':
            column.statusCode === _unref(TEETH_STATUSES).removed,
          'periodontal-map-table__column--interactive': __props.isInteractive,
        }, "periodontal-map-table__column"])
        }, [
          (!__props.isReverse)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([{
            'periodontal-map-table__column-header--interactive': __props.isInteractive,
            'periodontal-map-table__column-header--removed':
              column.statusCode === _unref(TEETH_STATUSES).removed,
          }, "periodontal-map-table__column-header"]),
                onClick: ($event: any) => (handleClickColumn($event, column.number))
              }, [
                (column.statusCode !== _unref(TEETH_STATUSES).removed)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(column.number), 1))
                  : (_openBlock(), _createBlock(_component_icon_template, {
                      key: 1,
                      class: "periodontal-map-table__column-header-icon",
                      height: "12",
                      name: "removed",
                      width: "12"
                    }))
              ], 10, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass([{
            'periodontal-map-table__column-content--hidden':
              column.statusCode === _unref(TEETH_STATUSES).removed,
            'periodontal-map-table__column-content--interactive': __props.isInteractive,
          }, "periodontal-map-table__column-content"])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([{
              'periodontal-map-table__mobility--preview': _unref(isPreviewMode),
              'periodontal-map-table__mobility--pdf': __props.isPdfMode,
              'periodontal-map-table__mobility--interactive': __props.isInteractive,
            }, "periodontal-map-table__mobility"]),
              onClick: ($event: any) => (handleChangeMobility(column.number))
            }, _toDisplayString(column.mobility), 11, _hoisted_4),
            _createElementVNode("div", {
              class: _normalizeClass([{
              'periodontal-map-table__furation-wrapper--double':
                column.furation.length === 2,
              'periodontal-map-table__furation-wrapper--hidden':
                column.statusCode === _unref(TEETH_STATUSES).implant,
              'periodontal-map-table__furation-wrapper--interactive':
                __props.isInteractive,
            }, "periodontal-map-table__furation-wrapper"])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.furation, (furation, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                'periodontal-map-table__furation--preview': _unref(isPreviewMode),
                'periodontal-map-table__furation--pdf': __props.isPdfMode,
                'periodontal-map-table__furation--interactive': __props.isInteractive,
              }, "periodontal-map-table__furation"]),
                  onClick: ($event: any) => (handleChangeFuration(column.number, index))
                }, _toDisplayString(furation), 11, _hoisted_5))
              }), 256))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([{
              'periodontal-map-table__plaque--interactive': __props.isInteractive,
            }, "periodontal-map-table__plaque"])
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
                return _createElementVNode("div", {
                  class: _normalizeClass([{
                'periodontal-map-table__plaque-item--disabled':
                  !column.plaque[index],
                'periodontal-map-table__plaque-item--preview':
                  _unref(isPreviewMode) || __props.isPdfMode,
                'periodontal-map-table__plaque-item--interactive':
                  __props.isInteractive,
              }, "periodontal-map-table__plaque-item"]),
                  onClick: ($event: any) => (
                handleChangePeriodontalParameter('plaque', column.number, index)
              ),
                  onMouseover: _withModifiers(($event: any) => (
                handleChangePeriodontalParameter('plaque', column.number, index)
              ), ["shift"])
                }, null, 42, _hoisted_6)
              }), 64))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([{
              'periodontal-map-table__bleeding--interactive': __props.isInteractive,
            }, "periodontal-map-table__bleeding"])
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
                return _createElementVNode("div", {
                  class: _normalizeClass([{
                'periodontal-map-table__bleeding-item--disabled':
                  !column.bleeding[index],
                'periodontal-map-table__bleeding-item--preview':
                  _unref(isPreviewMode) || __props.isPdfMode,
                'periodontal-map-table__bleeding-item--interactive':
                  __props.isInteractive,
              }, "periodontal-map-table__bleeding-item"]),
                  onClick: ($event: any) => (
                handleChangePeriodontalParameter(
                  'bleeding',
                  column.number,
                  index
                )
              ),
                  onMouseover: _withModifiers(($event: any) => (
                handleChangePeriodontalParameter(
                  'bleeding',
                  column.number,
                  index
                )
              ), ["shift"])
                }, null, 42, _hoisted_7)
              }), 64))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([{
              'periodontal-map-table__suppuration--interactive': __props.isInteractive,
            }, "periodontal-map-table__suppuration"])
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
                return _createElementVNode("div", {
                  class: _normalizeClass([{
                'periodontal-map-table__suppuration-item--disabled':
                  !column.suppuration[index],
                'periodontal-map-table__suppuration-item--preview':
                  _unref(isPreviewMode) || __props.isPdfMode,
                'periodontal-map-table__suppuration-item--interactive':
                  __props.isInteractive,
              }, "periodontal-map-table__suppuration-item"]),
                  onClick: ($event: any) => (
                handleChangePeriodontalParameter(
                  'suppuration',
                  column.number,
                  index
                )
              ),
                  onMouseover: _withModifiers(($event: any) => (
                handleChangePeriodontalParameter(
                  'suppuration',
                  column.number,
                  index
                )
              ), ["shift"])
                }, null, 42, _hoisted_8)
              }), 64))
            ], 2),
            (__props.isInteractive)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([{
              'periodontal-map-table__recession--interactive': __props.isInteractive,
            }, "periodontal-map-table__recession"])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.recession, (recessionItem, index) => {
                    return (_openBlock(), _createBlock(_component_el_input, {
                      modelValue: column.recession[index],
                      "onUpdate:modelValue": ($event: any) => ((column.recession[index]) = $event),
                      modelModifiers: { number: true },
                      key: index,
                      class: "periodontal-map-table__recession-item",
                      onInput: ($event: any) => (
                handleInput(
                  column.number,
                  index,
                  $event,
                  recessionItem,
                  'recession'
                )
              ),
                      onFocusout: ($event: any) => (
                handleFocusOutInput(
                  column.recession[index],
                  column.number,
                  index,
                  'recession'
                )
              ),
                      onFocusin: ($event: any) => (
                moveCursorToEndValue(
                  column.recession[index],
                  column.number,
                  index,
                  'recession'
                )
              ),
                      onClick: ($event: any) => (clearInputValue(column.number, index, 'recession')),
                      onKeyup: ($event: any) => (
                handleChangeInputByTab(
                  $event,
                  recessionInputs.value,
                  column.recession[index]
                )
              )
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput", "onFocusout", "onFocusin", "onClick", "onKeyup"]))
                  }), 128))
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.recession, (recessionItem, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(recessionItem), 1))
                  }), 128))
                ])),
            (__props.isInteractive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.sounding, (soundingItem, index) => {
                    return (_openBlock(), _createBlock(_component_el_input, {
                      key: index,
                      modelValue: column.sounding[index],
                      "onUpdate:modelValue": ($event: any) => ((column.sounding[index]) = $event),
                      modelModifiers: { number: true },
                      class: _normalizeClass([{
                'periodontal-map-table__sounding-danger': soundingItem >= 4,
              }, "periodontal-map-table__sounding-item"]),
                      onInput: ($event: any) => (
                handleInput(
                  column.number,
                  index,
                  $event,
                  soundingItem,
                  'sounding'
                )
              ),
                      onFocusout: ($event: any) => (
                handleFocusOutInput(
                  column.sounding[index],
                  column.number,
                  index,
                  'sounding'
                )
              ),
                      onFocusin: ($event: any) => (
                moveCursorToEndValue(
                  column.sounding[index],
                  column.number,
                  index,
                  'sounding'
                )
              ),
                      onClick: ($event: any) => (clearInputValue(column.number, index, 'sounding')),
                      onKeyup: ($event: any) => (
                handleChangeInputByTab(
                  $event,
                  soundingInputs.value,
                  column.sounding[index]
                )
              )
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "onInput", "onFocusout", "onFocusin", "onClick", "onKeyup"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.sounding, (soundingItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass({
                'periodontal-map-table__sounding-danger': soundingItem >= 4,
              })
                    }, _toDisplayString(soundingItem), 3))
                  }), 128))
                ]))
          ], 2),
          (__props.isReverse)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([{
            'periodontal-map-table__column-header--interactive': __props.isInteractive,
            'periodontal-map-table__column-header--removed':
              column.statusCode === _unref(TEETH_STATUSES).removed,
          }, "periodontal-map-table__column-header"]),
                onClick: ($event: any) => (handleClickColumn($event, column.number))
              }, [
                (column.statusCode !== _unref(TEETH_STATUSES).removed)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(column.number), 1))
                  : (_openBlock(), _createBlock(_component_icon_template, {
                      key: 1,
                      class: "periodontal-map-table__column-header-icon",
                      height: "12",
                      name: "removed",
                      width: "12"
                    }))
              ], 10, _hoisted_12))
            : _createCommentVNode("", true)
        ], 2))
      }), 256))
    ])
  ], 2))
}
}

})